import {
  BagCheckoutContainer,
  BagContentContainer,
  BagDynamicModal,
  BagScrollView,
} from './Containers';
import { BagPaymentHeaderContainer } from './Containers/BagPaymentHeaderContainer';
import {
  BagCheckoutCta,
  BagContinueToBagCta,
  BagContinueToCheckoutCta,
  BagCreditToggle,
  BagFloatingCtas,
  BagViewMenuCta,
} from './Ctas';
import { BagUtensilsCta } from './Ctas/BagUtensilsCta';
import { BagDisclosure } from './Disclosure';
import { BagDisclaimers, BagDiscount, BagFooter, BagSubtotal } from './Footer';
import { BagGiftCardForm } from './GiftCard';
import {
  BagAnimatedDialogTitle,
  BagChannelHeader,
  BagHeaderContainer,
  BagLocationAtConnector,
  BagLocationFromConnector,
  BagLocationHeader,
  BagLocationToConnector,
  BagTimeConnector,
  BagTimeHeader,
} from './Header';
import { BagHeaderLine } from './Header/BagHeaderLine';
import { BagLedger } from './Ledger';
import { BagOrderPlayback } from './OrderPlayback';
import {
  BagDropoffLocationPicker,
  BagPaymentMethodGiftCardCta,
  BagTimePicker,
} from './Pickers';
import { BagPromoField, BagPromoRewardsContainer } from './PromoRewards';
import { BagEmptyState, BagLoadingState } from './States';
import { BagStripe, BagStripeOpacityAnimation } from './Stripe';
import {
  BagFutureDateWarning,
  BagNextDayOrderWarning,
  BagTimeslotUnavailableWarning,
  BagWarningModal,
} from './Warnings';

export { sumLedgerTotal } from './Ledger';
export { type OrderPlaybackConfig } from './OrderPlayback';

export const Bag = {
  //
  // ─── Containers ───────────────────────────────────────────────────────────

  DynamicModal: BagDynamicModal,
  ScrollView: BagScrollView,
  ContentContainer: BagContentContainer,
  CheckoutContainer: BagCheckoutContainer,
  PaymentHeaderContainer: BagPaymentHeaderContainer,

  // ─── States ───────────────────────────────────────────────────────────────

  LoadingState: BagLoadingState,
  EmptyState: BagEmptyState,

  // ─── Warnings ─────────────────────────────────────────────────────────────

  WarningModal: BagWarningModal,
  FutureDateWarning: BagFutureDateWarning,
  TimeslotUnavailableWarning: BagTimeslotUnavailableWarning,
  NextDayOrderWarning: BagNextDayOrderWarning,

  // ─── Order Playback ───────────────────────────────────────────────────────

  OrderPlayback: BagOrderPlayback,

  // ─── Pickers ──────────────────────────────────────────────────────────────

  TimePicker: BagTimePicker,
  DropoffLocationPicker: BagDropoffLocationPicker,
  PaymentMethodGiftCardCta: BagPaymentMethodGiftCardCta,

  // ─── Header ───────────────────────────────────────────────────────────────

  AnimatedDialogTitle: BagAnimatedDialogTitle,
  HeaderLine: BagHeaderLine,
  ChannelHeader: BagChannelHeader,
  HeaderContainer: BagHeaderContainer,
  LocationFromConnector: BagLocationFromConnector,
  LocationHeader: BagLocationHeader,
  LocationToConnector: BagLocationToConnector,
  LocationAtConnector: BagLocationAtConnector,
  TimeConnector: BagTimeConnector,
  TimeHeader: BagTimeHeader,

  // ─── Promo Code Rewards ───────────────────────────────────────────────────

  PromoRewardsContainer: BagPromoRewardsContainer,
  PromoField: BagPromoField,

  // ─── Giftcard ─────────────────────────────────────────────────────────────

  GiftCardForm: BagGiftCardForm,

  // ─── Disclosure ───────────────────────────────────────────────────────────

  Disclosure: BagDisclosure,

  // ─── Footer ───────────────────────────────────────────────────────────────

  Footer: BagFooter,
  Subtotal: BagSubtotal,
  Discount: BagDiscount,
  Disclaimers: BagDisclaimers,

  // ─── Checkout ─────────────────────────────────────────────────────────────

  CreditToggle: BagCreditToggle,
  Ledger: BagLedger,
  Stripe: BagStripe,
  StripeOpacityAnimation: BagStripeOpacityAnimation,

  // ─── CTAs ─────────────────────────────────────────────────────────────────

  ViewMenuCta: BagViewMenuCta,
  UtensilsCta: BagUtensilsCta,
  ContinueToBagCta: BagContinueToBagCta,
  ContinueToCheckoutCta: BagContinueToCheckoutCta,
  FloatingCtas: BagFloatingCtas,
  CheckoutCta: BagCheckoutCta,
};
